export const ROLE_NAMES = ['Hunter','Family','Friends','Worker','Manager','Admin'];
export const PRIVILEGE_KEYS = ['map','places','overview','scouting','projects','maintenance','assets','documents','settings','gpsTracking','contributionReview','communityParticipation','photoModeration','neighborContacts'];
const blank = () => Object.fromEntries(PRIVILEGE_KEYS.map(key => [key,{view:false,write:false}]));
const full = () => Object.fromEntries(PRIVILEGE_KEYS.map(key => [key,{view:true,write:true}]));
const guest = () => ({...blank(),map:{view:true,write:false},scouting:{view:true,write:true},gpsTracking:{view:true,write:false},communityParticipation:{view:true,write:true}});
const worker = () => ({...guest(),projects:{view:true,write:true},maintenance:{view:true,write:true},assets:{view:true,write:false},documents:{view:true,write:false}});
export const rolePrivilegeDefaults = {
  Admin:full(), Manager:{...full(),settings:{view:false,write:false}},
  Hunter:guest(),Family:guest(),Friends:guest(),Worker:worker(),VIP:guest(),Guest:guest()
};
export const getPrivilegesForRole = role => rolePrivilegeDefaults[role] || blank();
export function getPrivilegesForRoles(roles, definitions = []) {
  if (roles.includes('Admin')) return full();
  const result = blank();
  for (const role of roles) {
    const defaults = getPrivilegesForRole(role);
    const overrides = definitions.find(item=>item.role===role)?.privileges || {};
    for (const key of PRIVILEGE_KEYS) {
      const permission = overrides[key] || (key==='maintenance' ? overrides.projects : key==='projects' ? overrides.maintenance : undefined) || defaults[key];
      result[key].view ||= permission?.view === true;
      result[key].write ||= permission?.write === true;
    }
  }
  result.settings = {view:false,write:false};
  result.maintenance = {...result.projects};
  return result;
}
export const privilegeForTable = {
  users:'settings',roleDefinitions:'settings',userFarmMemberships:'settings',farms:'map',tasks:'maintenance',
  complianceEvents:'maintenance',documents:'documents',messages:'documents',links:'documents',mapFeatures:'map',
  assets:'assets',projects:'projects',workLogs:'projects',gpsTrackPoints:'gpsTracking',recordedRoutes:'gpsTracking',scoutingPhotos:'scouting',scoutingPhotoCategories:'scouting'
};
export const hasPrivilege = (privileges,key,write=false) => !!privileges?.[key]?.[write?'write':'view'];
